module.exports = __webpack_public_path__ + "static/media/saveramericas-logo.da8115e0.svg";